import React from 'react';
import PropTypes from 'prop-types';

const TextBoolean = ({ value }) => {
  let displayText = "Nei";
  if (value === true)
  {
    displayText = "Já";
  }
  return (
    <span>{displayText}</span>
  );
};

TextBoolean.propTypes = {
    value: PropTypes.bool,
};

export default TextBoolean;
